import AccountIcon from '@mui/icons-material/AccountCircle'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import DashboardIcon from '@mui/icons-material/Dashboard'
import EmailIcon from '@mui/icons-material/Email'
import FacebookIcon from '@mui/icons-material/Facebook'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import InsertPageBreakIcon from '@mui/icons-material/InsertPageBreak'
import Language from '@mui/icons-material/Language'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import MailIcon from '@mui/icons-material/Mail'
import PaymentIcon from '@mui/icons-material/Payment'
import PaymentsIcon from '@mui/icons-material/Payments'
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg'
import PinDrop from '@mui/icons-material/PinDrop'
import QuizIcon from '@mui/icons-material/Quiz'
import ReceiptIcon from '@mui/icons-material/Receipt'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import SavingsIcon from '@mui/icons-material/Savings'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import WarningIcon from '@mui/icons-material/Warning'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

import XIcon from '@mui/icons-material/X'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { ROUTES_PATH } from './routes'

export const EFFICIENCY_LINK = 'https://www.moval.org/mvu/efficiency-progs.html'
export const OUTAGES_LINK = 'https://delcowater.org/report-outage'
export const CONTACT_US_LINK = 'https://delcowater.org/contact-us/'
export const RATES_LINK = 'https://delcowater.org/water-rate/'
export const SAVINGS_LINK = 'https://delcowater.org/waterquality/'
export const PAPERLESS_LINK = 'https://invoicecloud.net/payer-terms-conditions'
export const CONTACT_EMAIL = 'information@delcowater.org'
export const CONTACT_PHONE = '740-548-7746'
export const CONTACT_PHONE_2 = '(740) 548-7746'
export const CONTACT_PHONE_3 = '800-521-6779'
export const PAY_BY_PHONE = '740-272-4276 | 2024'
export const WEBSITE = 'http://delcowater.org'
export const ADDRESS = '6658 Olentangy River Rd, Delaware, OH 43015'
export const SECOND_ADDRESS = '4940 ST RT 229 Marengo, OH 43334'

export const PAY_TOOLS = [
  { title: 'Autopay', Icon: CurrencyExchangeIcon, page: 3 },
  { title: 'Paperless Billing', Icon: InsertPageBreakIcon, page: 2 },
  { title: 'Pay Bill', Icon: PaymentsIcon, page: 1 },
  { title: 'Scheduled Payments', Icon: LocalAtmIcon, page: 9 },
  {
    title: 'View Bill',
    Icon: ReceiptIcon,
    navigate: ROUTES_PATH.BILLING
  },
  { title: 'Wallet', Icon: PaymentIcon, page: 5 }
]

export const LOGIN_ITEMS = [
  {
    title: 'Start or Stop Service',
    icon: FileCopyIcon,
    link: ROUTES_PATH.SERVICES
  },
  {
    title: 'One Time Payment',
    icon: PaymentsIcon,
    link: ROUTES_PATH.PAY
  },
  {
    title: 'Outages',
    icon: WarningIcon,
    link: OUTAGES_LINK
  },
  {
    title: 'Annual Water Quality Report',
    icon: SavingsIcon,
    link: SAVINGS_LINK
  },
  {
    title: 'FAQ',
    icon: QuizIcon,
    link: ROUTES_PATH.FAQS
  },
  {
    title: 'Contact Us',
    icon: ChatBubbleIcon,
    link: CONTACT_US_LINK
  }
]

export const SERVICE_ITEMS = [
  {
    title: 'Start Service',
    content:
      'To start new MVU electrical service, please call customer service at 1-844-341-6469.<br><br> Please have the following information available:',
    list: [
      'Service address.',
      'Social security number & driver\'s license number.',
      'Federal Tax ID# (if business).',
      'Primary phone number.',
      'Date to start service (additional fees apply for same day service, weekends, or holidays).',
      'Mailing address (if different from service address).'
    ],

    subcontent:
      '*Please note. There will be a $15.00 activation fee and a $5.00 per person identity verification charge applied to your account.'
  },
  {
    title: 'Stop service',
    content: 'To discontinue MVU residential or commercial electric service please call customer service at 1-844-341-6469. Please have the following information available:',
    list: ['Service address.', 'Personal identification information.']
  },
  {
    title: 'Move service',
    content: 'If you are moving within the MVU service territory please call customer service at 1-844-341-6469 and we\'d be happy to help you transfer your account to your new address.'
  }
]


export const SIDEBAR_ITEMS = [
  { title: 'Dashboard', icon: DashboardIcon, href: ROUTES_PATH.DASHBOARD },
  { title: 'Usage', icon: null, href: ROUTES_PATH.USAGE },
  { title: 'Billing', icon: ReceiptLongIcon, href: ROUTES_PATH.BILLING },
  { title: 'Services', icon: FileCopyIcon, href: ROUTES_PATH.AUTHORIZED_SERVICES },
  { title: 'Outages', icon: WarningAmberIcon, href: OUTAGES_LINK },
  // { title: 'Resident Resources', icon: SavingsIcon, href: ROUTES_PATH.RESIDENT_RESOURCES },
  { title: 'Contact Us', icon: ChatBubbleIcon, href: CONTACT_US_LINK },
  { title: 'My Account', icon: AccountIcon, href: ROUTES_PATH.ACCOUNT },
  { title: 'Account Preferences', icon: SettingsOutlinedIcon, href: ROUTES_PATH.SETTINGS },
  { title: 'FAQ', icon: QuizIcon, href: ROUTES_PATH.AUTHORIZEDFAQS }
]

export const UNAUTH_TOPBAR_ITEMS = [
  { title: 'Services', href: ROUTES_PATH.SERVICES },
  { title: 'Efficiency', href: ROUTES_PATH.EFFICIENCY },
  { title: 'Contact Us', href: ROUTES_PATH.CONTACT_US },
  { title: 'Outages', href: ROUTES_PATH.OUTAGES },
  { title: 'Frequently Ask Questions', href: ROUTES_PATH.FAQS }
]

export const TOPBAR_ITEMS = [
  { title: 'Usage', href: ROUTES_PATH.USAGE },
  { title: 'Billing', href: ROUTES_PATH.BILLING },
  // { title: 'Resident Resources', href: ROUTES_PATH.RESIDENT_RESOURCES },
  { title: 'Efficiency', href: ROUTES_PATH.EFFICIENCY },
  { title: 'Contact Us', href: ROUTES_PATH.CONTACT },
  { title: 'Account', href: ROUTES_PATH.ACCOUNT },
  { title: 'Account Preferences', href: ROUTES_PATH.SETTINGS },
  { title: 'Dashboard', href: ROUTES_PATH.PORTAL_DASHBOARD },
  { title: 'Outages', href: ROUTES_PATH.AUTHORIZED_OUTAGES },
  { title: 'FAQ', href: ROUTES_PATH.AUTHORIZEDFAQS },
  { title: 'Services', href: ROUTES_PATH.AUTHORIZED_SERVICES }
]

export const MESSAGES = {
  VERIFICATION_CODE_CHECK:
    'A verification code has been sent to your email. Please check your inbox and enter the code below.',
  VERIFICATION_RESENT:
    'A new verification code has been resent. Please allow a few minutes for its delivery. Kindly check your spam folder as well.',
  ACCOUNT_VERIFIED:
    'Your account has been successfully verified. Please proceed to create a password for registration.',
  REQUIRED_NAME_ERROR: 'Please provide your name in the required field.',
  REQUIRED_EMAIL_ERROR:
    'Please enter a valid email address in the required field.',
  REQUIRED_TELEPHONE_ERROR:
    'Please provide a valid telephone number in the required field.',
  REQUIRED_ACCOUNT_NUMBER:
    'Please enter a valid account number in the required field.',
  REQUIRED_SERVICE_ADDRESS:
    'Please enter a valid service address in the required field.',
  REPORT_OUTAGE_SUCCESS:
    'Thank you for reporting the outage. Your report has been successfully submitted and will be addressed as soon as possible.',
  SELECT_ONE_ERROR: 'Please select a topic before proceeding.',
  REQUIRED_SUBJECT_ERROR: 'Please enter a subject in the required field.',
  CONTACT_CUSTOMER_ERROR:
    'If this issue persists, please get in touch with our customer service team.',
  OUTAGE_RETRIEVE_ERROR: 'An error occurred while retrieving outage data: ',
  SOMETHING_WRONG_ERROR: 'Oops, something went wrong: ',
  PREFERENCES_UPDATED_SUCCESS:
    'Your preferences have been successfully updated.',
  PREFERENCES_WARN: 'Note: Standard message and data rates may apply.',
  PASSWORD_UPDATED_SUCCESS:
    'Your password has been changed successfully. Please log in using your new password.',
  PASSWORD_MATCH_ERROR: 'New Password and Confirm New Password do not match.',
  ZIP_CODE_ERROR: 'Please provide a valid zip code.',
  STREET_NAME_ERROR: 'Please enter a valid street name.',
  DATE_STOP_SERVICE_ERROR:
    'Please specify the date you would like to stop your service from.',
  WRONG_ERROR: 'Oops, an unexpected error occurred.',
  ENTER_DETAIL_ERROR:
    'Please provide details of your safety concern in the comments section.',
  SERVICE_REQUEST_SUCCESS:
    'Your service request has been successfully submitted.',
  RETRIEVE_ERROR:
    'We are currently experiencing technical difficulties and unable to retrieve your information. Please try again later.',
  IC_RETRIEVE_ERROR: 'Payments are temporarily unavailable.',
  ACCOUNT_RETRIEVE_ERROR:
    'An error occurred while retrieving your account information. Please try again later.',
  FORM_SUBMIT_ERROR:
    'An error occurred while submitting the form. Please try again.',
  FORM_SUBMIT_SUCCESS:
    'Your request has been submitted successfully. You will receive a response within 24 hours. You will now be redirected to the Dashboard.',
  BILL_PDF_ERROR:
    'We are currently unable to retrieve the PDF version of your bill. Please try again in 24-48 hours. You can view a summary of your bill and bill history on the billing tab.',
  ACCOUNT_UPDATED_SUCCESS:
    'Your account details has been successfully updated.',
  ACCOUNT_UPDATED_ERROR:
    'An error occurred while updating your account details. Please try again later.',
  UPDATE_LIMIT_EXCEEDED:
    'Please note that you can only update your mailing address once within a 24-hour period. Kindly try again later.',
  USER_CONFIRM_WARNING:
    'Please confirm your email address by entering the confirmation code sent to your inbox.',
  OUTAGES_ERROR:
    'An error occurred while retrieving your outage information. Please try again later.',
  OUTAGES_API_ERROR:
    'An error occurred while fetching outage information. Please try again later.',
  PAYMENT_INFO:
    'If you have made a payment, it may take a few minutes for the balance to reflect the payment.',
  BILL_ERROR:
    'We are currently unable to retrieve the PDF version of your bill. Please try again in 24-48 hours. You can view a summary of your bill and bill history on the billing tab.',
  ADMIN_ACCESS_ERROR: 'Administrators are not permitted to do this action.',
  VERIFY_PAY_BILL_ERROR:
    'An error occurred while retrieving your account information. Please double-check your details and try again.',
  VERIFY_PAY_BILL_ERROR_TEMP:
    'Please double check your account number or last name/business name. If this problem persists, call us at: (740) 548-7746',
  EMAIL_UPDATED_SUCCESS:
    'Your email has been changed successfully. Please log in using your new email.',
  INVALID_TELEPHONE_ERROR:
    'Please provide a valid telephone number.',
  IC_PAPERLESS_INFO:
    'If you’ve updated your preferences, please allow up to 10 minutes for it to reflect in your account',
  CLIPBOARD_COPY:
    'Address copied to clipboard.',
  CLIPBOARD_COPY_ERROR:
    'Failed to copy address.'
}

export const REGEX = {
  FIND_UNDERSCORE: /^[^_]*$/
}

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

export const USAGE_MENU_ITEMS = [
  { title: 'Calendar', label: 'Monthly View', icon: 'CalendarIcon' },
  { title: 'CalendarOne', label: 'Daily View', icon: 'Calendar1Icon' },
  { title: 'Clock', label: 'Hourly View', icon: 'ClockIcon' }
]


export const BILLING_QUESTIONS = [
  {
    title: 'When will I receive my bill?',
    content:
      'You will receive your bill on a monthly basis.'
  },
  {
    title: 'When is my bill due?',
    content:
      'Your payment due date is clearly indicated on both the top and bottom of the bill you have received in the mail or via email.'
  },
  {
    title: 'Why is my bill so high?',
    content: `Water bills are based on how much water is actually used. There are a number of different reasons that can contribute to a higher water bill. Watering the lawn or garden, additional occupants, and leaks can increase your water bill. The amount of days in the billing cycle can vary from month to month and occasionally there will be an extra week of usage.<br><br>
    Check your toilet. The most common and most costly water waste is from a leaking toilet. Have you heard your toilets refilling when not being used or does the handle sometimes get stuck? Sometimes there can be a leak that can’t even be seen or heard but a simple dye test can help determine if there is a problem. First, flush your toilet and after it fully refills put a few drops of food coloring in the back tank. Then, wait about an hour and see if any of the color comes down into the bottom bowl. If color shows up the flapper valve or plunger ball valve in the back tank may need replaced. Do this in each toilet in the house including ones that are rarely used.<br><br>
    If your toilet does not seem to be the cause there are several other possibilities that can account for higher usage. Be sure to check outdoor spigots and hoses, leaking faucets, hot water tanks, water softeners, ice makers, humidifiers or sump pumps that run on water back up. If none of these seem to solve your problem you may need to call a plumber or have your service line checked for leaks.`
  },
  {
    title: 'How can I pay my bill?',
    content: `Only payments with bill stubs can be mailed to the Post Office Box address on your bill. All other correspondence or payments without bill stubs (must include account number) can be mailed to:<br><br>
    6658 Olentangy River Rd<br>
    Delaware, OH 43015<br><br>
    <b>In Person:</b><br>
    6658 Olentangy River Rd<br>
    Delaware, OH 43015<br>
    740-548-7746<br><br>
    4940 ST RT 229<br>
    Marengo, OH 43334<br>
    419-253-6003<br><br>
    Office hours are Monday through Friday from 8:00am-4:30pm (Closed all major holidays)
    Night drop is available after hours at both Delaware and Marengo offices.<br><br>
    <b>All First Commonwealth Bank</b> branches(must have bill stub and will not accept payments from delinquent accounts)<br><br>
    <b>Automatic Payments</b><br>
    Will be drafted out of a checking account on or about due date of your invoice. You are able to sign up within the customer portal after you have signed in or please fill out the Automatic Payment Enroll Form and mail to: 6658 Olentangy River Rd. Delaware, OH 43015. There is no charge for this service.<br><br>
    <b>Automated phone payment with Debit/Credit Card or Electronic Check ($3.00 fee):</b><br>
    Please call 1-877-768-8261 or call our office and choose option 1 for Customer Service then choose option 2 for Automated Bill Payment System. If after hours please choose option 4. You may pay with Visa, MasterCard, and Discover or with an Electronic Check for an immediate payment. You must have your account number to use this option. If you have made a payment and your service has been disconnected or is in jeopardy of disconnection, a phone call to our office is required.<br><br>
    <b>Online with Debit or Credit card ($2.95 fee):</b><br>
    Immediate payments can be made using Visa, MasterCard and Discover by paying through our customer website here. Your card information is never saved and must be entered each time a payment is made. If you have made an online payment and your service has been disconnected or is in jeopardy of disconnection, a phone call to our office is required.<br><br>
    Contact your bank for details about paying through their online bill pay service.<br><br>
    There is a $20 charge for checks/ACH returned from a bank for any reason.<br><br>
    Account is considered paid when payment is received in the Del-Co Water offices. Del-Co is not responsible for mail service or electronic transactions.
    `
  },
  {
    title: 'Can I enroll in paperless billing?',
    content: `Yes! Once you log into your DelCo portal, click the Paperless Billing  Quick Link at the top of your page, or <a href=${ROUTES_PATH.SETTINGS} aria-label="Click here to enroll in paperless billing">click here.</a>`
  },
  {
    title: 'What should I do if I get behind in paying my bill?',
    content: 'We will work with you and will do our best to help avoid any termination of water service. Please call customer service Monday-Friday 8:00am-4:30pm before your service is due to be disconnected.'
  },
  {
    title: 'Do you have a minimum bill?',
    content: 'Yes, each user shall pay a minimum charge for each meter based on the size of the meter installed, for which the user will be entitled to the quantity of water set in the metered schedule of rates.'
  },
  {
    title: 'Do you offer discounts for filling pools or watering sod?',
    content: 'No we do not. All water used is billed the same regardless of how the water is used.'
  },
  {
    title: 'Delinquent Account Information:',
    content: 'A delinquent notice will be mailed to the customer if the amount due on the account has not been paid in full by the due date of a regular invoice. Failure to pay past due balances may result in additional fees and the disconnection of water service. Receiving a regular invoice after a delinquent notice has been issued does not change the disconnect date indicated on the delinquent notice. Please notify Del-Co water of payments made toward delinquent accounts. Should the water service to a delinquent property be disconnected the delinquent account balance and all associated fees must be paid in full before water service is restored. Water service may not be restored the same day it was disconnected.'
  },
  {
    title: 'How do I sign up for notifications?',
    content:
      `Notification preferences are set in the <a href=${ROUTES_PATH.SETTINGS}>Account Preferences page</a>`
  },
  {
    title: 'What do I do if I have a question about my bill?',
    content: 'You can either contact us through the Contact Us form (see below), or send us an email at information@delcowater.org, or you can call us at: (740) 548-7746.'
  }
]


export const CONTACT_INFORMATION = [
  {
    image: Language,
    title: 'Website',
    description: `<a target="_blank" rel="noopener noreferrer" href=${WEBSITE}>${WEBSITE}</a>`
  },
  {
    image: EmailIcon,
    title: 'Email',
    description: `<a href="mailto:${CONTACT_EMAIL}">Send an Email</a>`
  },
  {
    image: PinDrop,
    title: 'DelCo Water Company, Inc.',
    description: `Corporate Office<br>
                  ${ADDRESS}<br><br>
                  Satellite Office<br>
                  ${SECOND_ADDRESS}
    `
  }
]

export const CONTACT_SOCIAL_ITEMS = [
  {
    icon: XIcon,
    title: '@DelcoWater',
    link: 'https://x.com/DelcoWater',
    ariaLabel: 'X account Delco Water'
  },
  {
    icon: YouTubeIcon,
    title: '@Del-Co Water',
    link: 'https://www.youtube.com/@del-cowater5844/',
    ariaLabel: 'YouTube account DelCo Water'
  },
  {
    icon: LinkedInIcon,
    title: '/del-co-water-company',
    link: 'https://www.linkedin.com/company/del-co-water-company/',
    ariaLabel: 'LinkedIn account for DelCo Water'
  },
  {
    icon: FacebookIcon,
    title: '/delcowater',
    link: 'https://www.facebook.com/delcowater/',
    ariaLabel: 'Facebook account for DelCo Water'
  },
  {
    icon: PermPhoneMsgIcon,
    title: CONTACT_PHONE_2,
    link: `tel:${CONTACT_PHONE}`,
    ariaLabel: 'Phone number for DelCo Water'
  },
  {
    icon: EmailIcon,
    title: CONTACT_EMAIL,
    link: `mailto:${CONTACT_EMAIL}`,
    ariaLabel: 'Email address for DelCo Water'
  }
]

export const FOOTER_SOCIAL_LINKS = [
  {
    icon: XIcon,
    link: 'https://twitter.com/DelcoWater?s=20',
    name: 'X (Twitter)'
  },
  {
    icon: YouTubeIcon,
    link: 'https://www.youtube.com/channel/UChL7uELht-dgiBvJK0VU0ow',
    name: 'YouTube'
  },
  {
    icon: LinkedInIcon,
    link: 'https://www.linkedin.com/company/del-co-water-company',
    name: 'LinkedIn'
  },
  {
    icon: FacebookIcon,
    link: 'https://www.facebook.com/delcowater/',
    name: 'Facebook'
  }
]


export const TOPIC_ITEMS = ['Billing', 'Water Quality', 'Purchase a Tap', 'Backflow', 'Yard Repair', 'New Service', 'Water Leak', 'Other']


export const EFFICIENCY_DATA = {
  title: 'Efficiency',
  subtitle: '',
  type: 'items',
  itemBackground: true,
  items: [
    {
      title: 'AC or HP Tune-up Rebate',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    },
    {
      title: 'Business Rebate Application',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    },
    {
      title: 'Commercial Energy Audit...',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    },
    {
      title: 'Energy Efficiency Program...',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    }
  ]
}

export const ServicesFooterButtonData = [
  {
    title: 'Frequently Ask Questions',
    desc: 'Do you have any doubts or questions? Please visit our frequently questions to find your answer.',
    link: ROUTES_PATH.FAQS,
    linkTitle: 'Go to FAQ',
    icon: QuizIcon
  },
  {
    title: 'Contact Us',
    desc: 'Need additional assistance? Contact us, we are here to help you.',
    link: CONTACT_US_LINK,
    linkTitle: 'Go to Contact Us',
    icon: MailIcon
  }
]

export const ServiceFormRequestType = {
  startService: 'START',
  stopService: 'STOP',
  meterReadVerification: 'MRV',
  safety: 'SAFETY'
}

export const FAQS_ITEMS = [
  {
    ul: [
      {
        title: 'Why is my bill so high?',
        content: `Water bills are based on how much water is actually used. There are a number of different reasons that can contribute to a higher water bill. Watering the lawn or garden, additional occupants, and leaks can increase your water bill. The amount of days in the billing cycle can vary from month to month and occasionally there will be an extra week of usage.<br><br>
        Check your toilet. The most common and most costly water waste is from a leaking toilet. Have you heard your toilets refilling when not being used or does the handle sometimes get stuck? Sometimes there can be a leak that can’t even be seen or heard but a simple dye test can help determine if there is a problem. First, flush your toilet and after it fully refills put a few drops of food coloring in the back tank. Then, wait about an hour and see if any of the color comes down into the bottom bowl. If color shows up the flapper valve or plunger ball valve in the back tank may need replaced. Do this in each toilet in the house including ones that are rarely used.<br><br>
        If your toilet does not seem to be the cause there are several other possibilities that can account for higher usage. Be sure to check outdoor spigots and hoses, leaking faucets, hot water tanks, water softeners, ice makers, humidifiers or sump pumps that run on water back up. If none of these seem to solve your problem you may need to call a plumber or have your service line checked for leaks.`
      },
      {
        title: 'How can I pay my bill?',
        content: `Only payments with bill stubs can be mailed to the Post Office Box address on your bill. All other correspondence or payments without bill stubs (must include account number) can be mailed to:<br><br>
        6658 Olentangy River Rd<br>
        Delaware, OH 43015<br><br>
        <b>In Person:</b><br>
        6658 Olentangy River Rd<br>
        Delaware, OH 43015<br>
        740-548-7746<br><br>
        4940 ST RT 229<br>
        Marengo, OH 43334<br>
        419-253-6003<br><br>
        Office hours are Monday through Friday from 8:00am-4:30pm (Closed all major holidays)
        Night drop is available after hours at both Delaware and Marengo offices.<br><br>
        <b>All First Commonwealth Bank</b> branches(must have bill stub and will not accept payments from delinquent accounts)<br><br>
        <b>Automatic Payments</b><br>
        Will be drafted out of a checking account on or about due date of your invoice. You are able to sign up within the customer portal after you have signed in or please fill out the Automatic Payment Enroll Form and mail to: 6658 Olentangy River Rd. Delaware, OH 43015. There is no charge for this service.<br><br>
        <b>Automated phone payment with Debit/Credit Card or Electronic Check ($3.00 fee):</b><br>
        Please call 1-877-768-8261 or call our office and choose option 1 for Customer Service then choose option 2 for Automated Bill Payment System. If after hours please choose option 4. You may pay with Visa, MasterCard, and Discover or with an Electronic Check for an immediate payment. You must have your account number to use this option. If you have made a payment and your service has been disconnected or is in jeopardy of disconnection, a phone call to our office is required.<br><br>
        <b>Online with Debit or Credit card ($2.95 fee):</b><br>
        Immediate payments can be made using Visa, MasterCard and Discover by paying through our customer website here. Your card information is never saved and must be entered each time a payment is made. If you have made an online payment and your service has been disconnected or is in jeopardy of disconnection, a phone call to our office is required.<br><br>
        Contact your bank for details about paying through their online bill pay service.<br><br>
        There is a $20 charge for checks/ACH returned from a bank for any reason.<br><br>
        Account is considered paid when payment is received in the Del-Co Water offices. Del-Co is not responsible for mail service or electronic transactions.
        `
      },
      {
        title: 'Why do I have no water?',
        content: `If you have no water, there are a few possible reasons for the interruption of service:<br><br>
        • Non-Payment or a bad check received for payment.<br>
        • No billing information for a new account.<br>
        • Construction or repair of water lines near your home.<br>
        • An emergency outage in your area. Please call our office at 740-548-7746.<br>
        • Check the main shut off valve if house has been vacant or work has been done at your house.<br><br>
        • Freezing temperatures and blowing winds can be the culprits for frozen pipes and meters. If you have lost all water throughout the house check to see if the main service line coming into the house through the foundation is frozen. If you have lost water to only a certain area of you home check for frozen pipes along exterior walls. If a frozen pipe is not the culprit, you may have a frozen meter and will need to call our office at 740-548-7746.`
      },
      {
        title: 'How can I set up or stop service at a property?',
        content: 'Please contact our Customer Service department to set up or discontinue service. We will need at least one business day notice and can complete final readings on a Monday, Tuesday, Wednesday or Friday. We do not do final readings on Thursdays or weekends.'
      },
      {
        title: 'How can I update billing or account information?',
        content: 'Please contact our Customer Service department Monday thru Friday from 8:00am-4:30pm at 740-548-7746.'
      },
      {
        title: 'Can I enroll in paperless billing?',
        content: `Yes! Once you log into your DelCo portal, click the Paperless Billing  Quick Link at the top of your page, or <a href=${ROUTES_PATH.SETTINGS} aria-label="Click here to enroll in paperless billing">click here.</a>`
      },
      {
        title: 'What should I do if I get behind in paying my bill?',
        content: 'We will work with you and will do our best to help avoid any termination of water service. Please call customer service Monday-Friday 8:00am-4:30pm before your service is due to be disconnected.'
      },
      {
        title: 'Do you have a minimum bill?',
        content: 'Yes, each user shall pay a minimum charge for each meter based on the size of the meter installed, for which the user will be entitled to the quantity of water set in the metered schedule of rates.'
      },
      {
        title: 'Do you offer discounts for filling pools or watering sod?',
        content: 'No we do not. All water used is billed the same regardless of how the water is used.'
      },
      {
        title: 'Do you provide sewer or trash?',
        content: 'No we do not. Del-Co Water only provides water.'
      },
      {
        title: 'Delinquent Account Information:',
        content: 'A delinquent notice will be mailed to the customer if the amount due on the account has not been paid in full by the due date of a regular invoice. Failure to pay past due balances may result in additional fees and the disconnection of water service. Receiving a regular invoice after a delinquent notice has been issued does not change the disconnect date indicated on the delinquent notice. Please notify Del-Co water of payments made toward delinquent accounts. Should the water service to a delinquent property be disconnected the delinquent account balance and all associated fees must be paid in full before water service is restored. Water service may not be restored the same day it was disconnected.'
      },
      {
        title: 'Why is my water discolored?',
        content: 'Discolored water usually comes from mineral deposits that get stirred up during hydrant flushing, a water main break, or routine maintenance.  If you see discolored water, flush your faucets (<b>cold water only</b>) for 5-10 minutes.  If the water does not return to normal, please call 740-548-7746 and ask for our Water Quality Department.'
      },
      {
        title: 'Why is my water cloudy?',
        content: 'Cloudy or milky-looking water usually comes from dissolved air in the water.  Air in the water is harmless.  The amount of air in the water can change as the temperature of the water changes (for example, cold nights followed by hot days).  Air can also get into the pipes after a water main break.  In either case, to remove the air, you can flush your faucets (<b>cold water only</b>) for 5-10 minutes.  If the water does not return to normal, please call 740-548-7746 and ask for our Water Quality Department.'
      },
      {
        title: 'What is the hardness of my water?',
        content: '“Hard water” refers to the minerals (e.g., calcium and magnesium) that are dissolved in your water.  During the treatment process, Del-Co lowers the hardness of the water by removing some of these minerals.  There are many ways to measure water hardness.  Del-Co Water is approximately 7 – 8 grains per gallon.  This is equivalent to 120 – 140 mg/L (or parts per million).  If you need a more specific hardness concentration, please call 740-548-7746.   '
      },
      {
        title: 'Is there fluoride in my water?',
        content: "As part of the treatment process, Del-Co does add fluoride to the water.  We do this in a manner that is consistent with EPA regulations.  For more information, please follow this link: <a class='accordion-link' target='_blank' href='https://www.cdc.gov/fluoridation/about/'>https://www.cdc.gov/fluoridation/about/</a>."
      },
      {
        title: 'Why does my water smell different?',
        content: `There are many potential causes why your water may taste/smell different.  Following are possible reasons for a change in the taste/smell:<br><br>
        Rotten Egg (sulfur) – this odor usually comes from either the drain or the hot water tank.  If you suspect the drain, clean the drain with a diluted chlorine bleach solution or with white vinegar and this should clear up the problem.  If you suspect the hot water tank, there may be bacteria in the tank that are causing the sulfur smell.  Also, an odor coming from the hot water tank may be associated with the magnesium rod in the tank.<br><br>
        Musty (stagnant) – in the cold water, this is generally caused by algae growth in the source water or turnover in our reservoirs.  These events tend to be short-lived and happen in the spring or fall.  In the hot water, a musty smell can be caused by a decay in the hot water heater.  If this is the case, you can flush the hot water tank to clear up the issue.<br><br>
        Chlorine – Del-Co uses chlorine as the primary disinfectant for your water, so it is normal to smell chlorine.  If you notice a difference in the chlorine smell, it is most likely due to the free chlorine being lower than the total chlorine.  Water temperature can also influence the chlorine smell, so you may notice seasonal changes.<br><br>
        Copper – a copper taste is caused by the deterioration of the inside of copper pipes.
        `
      },
      {
        title: 'Why are there particles in my water?',
        content: `Black Particles – usually caused by a black rubber bladder or washer in the faucet, but can also come from mineral deposits that break loose during hydrant flushing, a water main break, or routine maintenance.<br><br>
        White Particles – these particles can come from the dip tube in the hot water tank.  Many hot water tanks that were made during the 1990s had defective dip tubes that were made of plastic.  This plastic can deteriorate over time and show up in your tap water.`
      },
      {
        title: 'Why is there a pink/red/black growth in my shower or toilet?',
        content: 'The red or pink growth is likely caused by a harmless bacterium named Serratia Marcescens.  This can grow on wet surfaces and the organisms grow rapidly together to form a ring.  Other bacteria or mold can also grow on moist surfaces and may be brown, black, or orange in color – the color depends on they type of bacteria or mold.  To control this growth, clean the area with a dilute bleach solution or white vinegar on a regular basis.'
      },
      {
        title: 'What causes pinhole leaks in my water pipes?',
        content: 'Pinhole leaks occur in copper pipes and are caused by dissimilar metals rubbing against each other.  The corrosion and resulting leak may not occur where the two metals are in contact and the corrosion can occur anywhere in the copper pipe.'
      }
    ]
  }
]
